import React from 'react';
import { Button } from '@iwoca/orion';
import clsx from 'clsx';
import { useIntroducerContext } from 'contexts/IntroducerContext/IntroducerContext';
import PdfIcon from 'svg/PdfIcon';

import styles from '../ProductItems.module.css';
import {
  IWOCAPAY_ACCOUNTANTS_URL,
  IWOCAPAY_BROKERS_URL,
} from './productGuidesLinks';

type Props = {
  unlockURL: string;
};

export const IwocaPay = ({ unlockURL }: Props) => {
  const { availableProducts, introducerType } = useIntroducerContext();
  const hasIwocaPay = availableProducts?.includes('iwocapay');
  const isAccountant = introducerType === 'accountant';

  const renderAction = () => {
    if (hasIwocaPay) {
      return (
        <Button
          className={clsx('linkButton', styles.inlineCtaButton)}
          size="small"
          href="https://share.hsforms.com/1iAgfTUnoR4a4_qzyDEdGGA3rrot"
          target="_blank"
          rel="noreferrer"
        >
          Refer clients to iwocaPay
        </Button>
      );
    }

    return (
      <Button
        className={clsx('linkButton', styles.inlineCtaButton)}
        variant="denim"
        size="small"
        href={unlockURL}
        target="_blank"
        rel="noreferrer"
      >
        Unlock iwocaPay
      </Button>
    );
  };

  return (
    <div className={styles.content}>
      <h2 className={styles.title}>iwocaPay</h2>
      <p className={styles.intro}>
        Get your clients their invoices paid sooner by offering flexible payment
        options without the risk.
      </p>
      <ul className={styles.benefits}>
        <li className={styles.benefit}>
          Spread the cost over<strong>3 months for 4%</strong>
        </li>
        <li className={styles.benefit}>
          Settle up in <strong>seconds for free</strong>
        </li>
        <li className={styles.benefit}>
          <span className={styles.benefitLabel}>Invoices up to</span>
          <strong>£15,000</strong>
        </li>
      </ul>
      {renderAction()}
      <div className={styles.footer}>
        <PdfIcon />
        <a
          href={isAccountant ? IWOCAPAY_ACCOUNTANTS_URL : IWOCAPAY_BROKERS_URL}
          target="_blank"
          rel="noreferrer"
        >
          iwocaPay guide
        </a>
      </div>
    </div>
  );
};
